import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import theme from 'theme'

import TextButton from './TextButton'

const CopyButton: React.FC<{
  content: string
  colorTheme: 'light' | 'dark'
}> = ({ content, colorTheme, ...rest }) => {
  const [isCopied, setIsCopied] = React.useState(false)
  const timeoutRef = React.useRef(null)
  React.useEffect(() => {
    if (isCopied) {
      timeoutRef.current = setTimeout(() => setIsCopied(false), 3000)
    }
    return () => clearTimeout(timeoutRef.current)
  }, [isCopied, timeoutRef])
  return (
    <CopyToClipboard text={content} onCopy={() => setIsCopied(true)}>
      <TextButton
        creative={isCopied}
        css={[
          {
            marginTop: theme.space[0],
            marginLeft: 'auto',
            transition: 'color 400ms ease',
            fontSize: theme.fontSizes[0]
          },

          colorTheme === 'light' && [
            {
              color: theme.colors.white[0],

              '&:hover, &:focus': {
                color: theme.colors.white[0]
              }
            }
          ],

          colorTheme !== 'light' && [
            {
              color: theme.colors.steel[1]
            },

            isCopied && {
              color: theme.colors.green[0]
            }
          ]
        ]}
        {...rest}
      >
        {isCopied ? 'Copied' : 'Copy to clipboard'}
      </TextButton>
    </CopyToClipboard>
  )
}

export { CopyButton }
